import { FormProvider } from 'react-hook-form';
import { useUnlistedStudyForm } from '@vivli/features/data-requests/infrastructure/hook';
import { AddUnlistedStudyComponent, AddUnlistedStudyComponentProps } from './add-unlisted-study.component';

export const AddUnlistedStudyModalComponent = (props: AddUnlistedStudyComponentProps) => {
    const formApi = useUnlistedStudyForm();

    return (
        <FormProvider {...formApi}>
            <AddUnlistedStudyComponent {...props} />
        </FormProvider>
    );
};
